module.exports = __webpack_public_path__ + "img/3.75e17e39.png";